<script lang="ts" setup>
import type { OrderDto, OrderExpense, OrderPayment } from "@/api/orders/dto/order.dto";
import OrderPaymentsTable from "@/views/orders/view/components/OrderPaymentsTable.vue";
import OrderExpensesTable from "@/views/orders/view/components/OrderExpensesTable.vue";
import OrderMoneyResult from "@/views/orders/view/components/OrderMoneyResult.vue";
import type { TravelOrderDto } from "@/api/trips/dto/trip.dto";

const props = defineProps<{
  order: OrderDto;
  travelOrders: TravelOrderDto[];
}>();

const emits = defineEmits<{
  (e: "succcess-create-payment", payment: OrderPayment): void;
  (e: "success-edit-payment", payment: OrderPayment): void;
  (e: "success-delete-payment", payment: OrderPayment): void;
  (e: "success-create-expense", expense: OrderExpense): void;
  (e: "success-edit-expense", expense: OrderExpense): void;
  (e: "success-delete-expense", expense: OrderExpense): void;
}>();
</script>

<template>
  <div>
    <order-payments-table
      :order="order"
      class="mt-6"
      @succcess-create-payment="emits('succcess-create-payment', $event)"
      @success-edit-payment="emits('success-edit-payment', $event)"
      @success-delete-payment="emits('success-delete-payment', $event)"
    />

    <order-expenses-table
      :order="order"
      class="mt-6"
      @success-create-expense="emits('success-create-expense', $event)"
      @success-edit-expense="emits('success-edit-expense', $event)"
      @success-delete-expense="emits('success-delete-expense', $event)"
    />

    <order-money-result
      :order-expenses="order.expenses"
      :order-payments="order.orderPayments"
      :travel-orders="travelOrders"
      class="mt-6"
    />
  </div>
</template>

<style lang="scss" scoped></style>
